import { useLocation } from 'react-router';

export const normalizePath = (path: string) =>
    path.endsWith('/') ? path.substring(0, path.length - 1) : path;

export const useNormalizedPath = () => {
    const { pathname } = useLocation();

    const lowerCasedPath = pathname.toLowerCase();

    return normalizePath(lowerCasedPath);
};
